import Api from './Api'

export default {
    getBuscarEspecialistas(uf, city, page) {
        return Api().get(`/members?uf=${uf}&city=${city}&page=${page}`);
    }
}